import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/store";
import {
  GetStagesRequest,
  Stage,
} from "@/modules/administration/features/StageManagement/api/getStages/types";
import { getStages } from "@/modules/administration/features/StageManagement/api/getStages/getStagesApi";

interface StageState {
  stages: Stage[];
  totalCount: number;
  loadingList: boolean;
  listError: string | null;
}

const initialState: StageState = {
  stages: [],
  totalCount: 0,
  loadingList: false,
  listError: null,
};

const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    setLoadingList(state, action: PayloadAction<boolean>) {
      state.loadingList = action.payload;
    },
    setListError(state, action: PayloadAction<string | null>) {
      state.listError = action.payload;
    },
    setStagesData(
      state,
      action: PayloadAction<{ stages: Stage[]; totalCount: number }>,
    ) {
      state.stages = action.payload.stages;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoadingList, setListError, setStagesData } =
  stageSlice.actions;

export default stageSlice.reducer;

export const getStagesAction =
  (
    params?: GetStagesRequest,
    onSuccess?: (stages: Stage[]) => void,
  ): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoadingList(true));
    dispatch(setListError(null));
    try {
      const response = await getStages(params);
      const stages = response.data;
      dispatch(
        setStagesData({
          stages,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
      if (onSuccess) {
        onSuccess(stages);
      }
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Failed to fetch stages.";
      dispatch(setListError(message));
    } finally {
      dispatch(setLoadingList(false));
    }
  };
